<template>
  <div class="vx-card">
    <div class="flex justify-between" style="padding: 1.5rem;">
      <div class="font-bold" style="font-size: 14px;"><i class="dot" /> 안전보건 점검 미이행 현황</div>
      <div @click="moveDetailPage" class="cursor-pointer" style="color: rgba(var(--vs-primary),1);  font-size:0.85em; display:flex; align-items: center; justify-content: flex-end;">자세히 보기 <feather-icon icon="ChevronRightIcon" style="width:1.42em;"/></div>
    </div>
    <div class="flex justify-start" style="padding: 1.5rem;">
      <vs-tabs v-model="tabIndex">
        <!--전체, 휴게시설, 급식종사자, 당직업무, 통학보조, 시설관리, 미화원, 물질 안전·보건자료-->
        <vs-tab label="전체" />
        <vs-tab label="휴게시설" />
        <vs-tab label="급식종사자" />
        <vs-tab label="당직업무" />
        <vs-tab label="통학보조" />
        <vs-tab label="시설관리" />
        <vs-tab label="미화원" />
        <vs-tab label="물질 안전·보건자료" />
      </vs-tabs>
    </div>
    <apexchart type="bar" :options="chartOptions" :series="currentSeries" height="250" />
  </div>
</template>

<script lang="ts">
export default {
  name: 'HealthSafetyInspectionNotPerformedChart',
  created() {
    for (const key of Object.keys(this.allSeries)) {
      this.allSeries[key] = [...this.series];
    }
  },
  mounted() {
    console.log('mounted');
    this.loadApi();
  },
  data() {
    return {
      tabIndex: 0,
      fieldList: [],
      facilityCategoryByFieldId: {},
      // 퍼센트 계산을 위한, 미이행 사업장 ID 목록
      notPerformedFieldIds: [],
      // 그래프에서 추출하려고 하는 시설물 분류 값, 그 외에는 "기타"에 포함시킨다
      targetFacilityCategory: ['기계공학과', '토목공학과', '건축공학과', '법학과'],
      targetFacilityCategoryCount: {
        '기계공학과': 0,
        '토목공학과': 0,
        '건축공학과': 0,
        '법학과': 0,
        '기타': 0,
      },
      allSeries: {
        '전체': [],
        '휴게시설': [],
        '급식종사자': [],
        '당직업무': [],
        '통학보조': [],
        '시설관리': [],
        '미화원': [],
        '물질 안전·보건자료': [],
      },
      series: [
        {
          name: '기계공학과',
          data: [0, 0, 0, 0],
        }, {
          name: '토목공학과',
          data: [0, 0, 0, 0]
        }, {
          name: '건축공학과',
          data: [0, 0, 0, 0]
        }, {
          name: '법학과',
          data: [0, 0, 0, 0]
        }, {
          name: '기타',
          data: [0, 0, 0, 0]
        }
      ],
      chartOptions: {
        chart: {
          type: 'bar',
          height: 250,
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '55%',
            endingShape: 'rounded'
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          show: true,
          width: 2,
          colors: ['transparent']
        },
        xaxis: {
          categories: ['1분기', '2분기', '3분기', '4분기'],
        },
        yaxis: {
          title: {
            text: '(개소)',
          }
        },
        fill: {
          opacity: 1
        },
        tooltip: {
          y: {
            formatter (val) {
              return `${val  }개소`
            }
          }
        }
      }
    }
  },
  emits: ['update:percent'],
  computed: {
    currentSeries() {
      return this.allSeries[Object.keys(this.allSeries)[this.tabIndex]];
    }
  },
  methods: {
    moveDetailPage() {
      this.$router.push('/project/6/graph-detail/HealthSafetyInspectionNotPerformedChart');
    },
    extractQuarterData(yearData) {
      const quarterData = [];
      for (let i = 0; i < 4; i++) {
        quarterData.push([]);
      }
      let month = 0;
      for (const monthData of yearData) {
        if (month === 0) {
          month += 1;
          continue;
        }
        const quarter = Math.floor((month - 1) / 3);
        for (const fieldId of monthData) {
          quarterData[quarter].push(fieldId);
          this.notPerformedFieldIds.push(fieldId);
        }

        month += 1;
      }

      const resultSeries = JSON.parse(JSON.stringify(this.series));
      for (let quarterIndex = 0; quarterIndex < 4; quarterIndex++) {
        const quarter = [...new Set(quarterData[quarterIndex])];

        for (const fieldId of quarter) {
          const cat3 = this.facilityCategoryByFieldId[fieldId];
          for (const series of resultSeries) {
            if (series.name === cat3) {
              series.data[quarterIndex] += 1;
              break;
            }
          }
        }
      }

      for (const series of resultSeries) {
        for (let i = 0; i < 4; i++) {
          const cat3Count = this.targetFacilityCategoryCount[series.name];
          series.data[i] = cat3Count - series.data[i];
        }
      }

      return resultSeries;
    },
    async loadApi() {
      const data = await this.$store.dispatch('summary/LOAD_FIELD_NOT_PERFORMED_HS', {
        projectIds: [6],
      });

      this.fieldList = data.fields;

      for (const field of this.fieldList) {
        let cat3 = field.facility_category ? field.facility_category.cat3 : '기타';
        if (!this.targetFacilityCategory.includes(cat3)) {
          cat3 = '기타';
        }
        this.facilityCategoryByFieldId[field.id] = cat3;
        this.targetFacilityCategoryCount[cat3] += 1;
      }

      const currentYear = new Date().getFullYear();

      // 전체
      const allData = data.notPerformedFieldIds.all[currentYear];
      this.allSeries['전체'] = this.extractQuarterData(allData);

      // 급식종사자
      const data519 = {};
      data519['급식종사자'] = data.notPerformedFieldIds['519']['급식종사자'][currentYear];
      this.allSeries['급식종사자'] = this.extractQuarterData(data519['급식종사자']);
      data519['당직업무'] = data.notPerformedFieldIds['519']['당직업무'][currentYear];
      this.allSeries['당직업무'] = this.extractQuarterData(data519['당직업무']);
      data519['통학보조'] = data.notPerformedFieldIds['519']['통학보조'][currentYear];
      this.allSeries['통학보조'] = this.extractQuarterData(data519['통학보조']);
      data519['시설관리'] = data.notPerformedFieldIds['519']['시설관리'][currentYear];
      this.allSeries['시설관리'] = this.extractQuarterData(data519['시설관리']);
      data519['미화원'] = data.notPerformedFieldIds['519']['미화원'][currentYear];
      this.allSeries['미화원'] = this.extractQuarterData(data519['미화원']);

      // 휴게시설
      const data438 = data.notPerformedFieldIds['438'][currentYear];
      this.allSeries['휴게시설'] = this.extractQuarterData(data438);

      // 물질 안전·보건자료
      const data490 = data.notPerformedFieldIds['490'][currentYear];
      this.allSeries['물질 안전·보건자료'] = this.extractQuarterData(data490);

      // 퍼센트 계산
      const fieldCount = this.fieldList.length;
      // this.notPerformedFieldIds 중복 제거
      this.notPerformedFieldIds = [...new Set(this.notPerformedFieldIds)];
      const notPerformedFieldCount = this.notPerformedFieldIds.length;
      const percent = 100 - Math.round((notPerformedFieldCount / fieldCount) * 100);
      this.$emit('update:percent', percent);
    }
  }
}
</script>

<style scoped>

</style>
